<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" class="entry-form">
<box class="account-sec">
	<app-account-det-list-control
			class="col-sm-12 col-lg-12 col-md-12"
			label="{{'ACCCHEQUEBOOK.accountNumber_lbl' | translate}}"
			placeholder="{{'ACCCHEQUEBOOK.accountNumber_placeholder' | translate}}"
			formControlName="accountNumber"
		></app-account-det-list-control>
</box>
 <box class="field-details">

		  <app-cheque-books-control
		  class="col-sm-12 col-lg-6 col-md-12"
		  label="{{'ACCCHEQUEBOOK.noOfChqBooks_lbl' | translate}}"
		  placeholder="{{'ACCCHEQUEBOOK.noOfChqBooks_placeholder' | translate}}"
		  formControlName="noOfChqBooks"
 ></app-cheque-books-control>
		  <app-cheque-book-leaves-control
		  class="col-sm-12 col-lg-6 col-md-12"
		  label="{{'ACCCHEQUEBOOK.noOfLeaves_lbl' | translate}}"
		  placeholder="{{'ACCCHEQUEBOOK.noOfLeaves_placeholder' | translate}}"
		  formControlName="noOfLeaves"
 ></app-cheque-book-leaves-control>
		<app-request-date-control
	  class="col-sm-12 col-lg-6 col-md-6"
      label="{{'ACCCHEQUEBOOK.requestDate_lbl' | translate}}"
      formControlName="requestDate"
      [minDate]="state.reqDate"

    [maxDate]="state.maxDate"
    ngModel
    required
></app-request-date-control>
		  <app-delivery-options-control
		  class="col-sm-12 col-lg-6 col-md-6"
		  label="{{'ACCCHEQUEBOOK.dlvryOption_lbl' | translate}}"
		  placeholder="{{'ACCCHEQUEBOOK.dlvryOption_placeholder' | translate}}"
		  formControlName="dlvryOption"
 ></app-delivery-options-control>
		  <app-branches-list-control
		  class="col-sm-12 col-lg-6 col-md-6" *ngIf="state.isBranchVisible"
		  label="{{'ACCCHEQUEBOOK.dlvryBranch_lbl' | translate}}"
		  placeholder="{{'ACCCHEQUEBOOK.dlvryBranch_placeholder' | translate}}"
		  formControlName="dlvryBranch"
 ></app-branches-list-control>
		 <app-remarks-control
		 class="col-sm-12 col-lg-6 col-md-6"
		 label="{{'ACCCHEQUEBOOK.remarks_lbl' | translate}}"
		 placeholder="{{'ACCCHEQUEBOOK.remarks_placeholder' | translate}}"
		 formControlName="remarks"
 ></app-remarks-control>
 </box>
</form>











